<!--详情页面-->
<template>
  <el-dialog
    :title="getTitle()"
    :visible.sync="dialogMachiningVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog"
  >
    <div ref="print1" style="width: 100%;margin: 0 auto;">
      <p :style="{display:showtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">{{getTitle()}}</p>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"  class="print-table">
        <tr class="noborder">
          <td align="left" style="width: 90px;">单号：</td>
          <td>
            {{controlData.erpserial}}
          </td>
          <td align="left" style="width: 90px;">仓&nbsp;&nbsp;&nbsp;&nbsp;库：</td>
          <td>
            {{controlData.cangkuname}}
          </td>
          <td align="left" style="width: 90px;">处理方式：</td>
          <td>
            {{handlemode}} <el-button type="primary" size="mini" @click="changeHandlemodel" v-if="false&&controlData.status==1">修改</el-button>
          </td>
        </tr>
        <tr class="noborder" v-if="handlemode=='退回供应商'">
          <td align="left" style="width: 90px;">退货单号：</td>
          <td>
            {{controlData.buyerpserial}}
          </td>
          <td align="left" style="width: 90px;">供应商：</td>
          <td>
            {{controlData.customername}}
          </td>
        </tr>
        <tr style="height: 20px"></tr>
        <tr>
          <td colspan="6" style="border:none">
            <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
                   class="query-table">
              <tr>
                <td style="text-align: center;" v-show="showJingPian">R/L</td>
                <td style="text-align: center;">产品名称</td>
                <td style="text-align: center;" v-show="showJingPian">球镜</td>
                <td style="text-align: center;" v-show="showJingPian">柱镜</td>
                <td style="text-align: center;" v-show="showJingJia">型号</td>
                <td style="text-align: center;" v-show="showJingJia">色号</td>
                <td style="text-align: center;">入库单号</td>
                <td style="text-align: center;" v-show="showJingPian">状态</td>
                <td style="text-align: center;">数量</td>
              </tr>
              <tr v-for="item in tableData">
                <td style="text-align: center;" v-show="showJingPian">{{getPack(item.packagesize,'type',item.formproperty)}}</td>
                <td style="text-align: left;minWidth:150px">{{item.seedname}}</td>
                <td style="text-align: center;" v-show="showJingPian">{{getPack(item.packagesize,'Y')}}</td>
                <td style="text-align: center;" v-show="showJingPian">{{getPack(item.packagesize,'X')}}</td>
                <td style="text-align: center;" v-show="showJingJia">{{getPack(item.packagesize,'M')}}</td>
                <td style="text-align: center;" v-show="showJingJia">{{getPack(item.packagesize,'C')}}</td>
                <td style="text-align: center;"><span @click="lookdingdan(item)" style="cursor: pointer;"><b>{{item.ordernum}}</b></span></td>
                <td style="text-align: center;" v-show="showJingPian">{{item.bigseedunit}}</td>
                <td style="text-align: center;">{{item.totalnumber}}</td>
              </tr>
            </table>
          </td>
        </tr>

        <tr style="height: 20px"></tr>
        <tr class="noborder">
          <td align="left">备注：</td>
          <td colspan="5" style="border: none;height: 30px">
           {{controlData.remark}}
          </td>
        </tr>
        <tr style="height: 20px"></tr>
        <tr class="noborder">
          <td align="left">处理人：</td>
          <td>
            {{controlData.uname}}
          </td>
          <td align="left">出库日期：</td>
          <td>
            {{controlData.adddate}}
          </td>
        </tr>
      </table>
      <BaoSunDetail ref="BaoSunDetail"></BaoSunDetail>
      <CstagreementEdit ref="DataContactEdit"></CstagreementEdit>
      <StorageBadChange ref="StorageBadChange" @bindData="afterChangeBad"></StorageBadChange>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogMachiningVisible = false;">关 闭</el-button>
      <el-button type="primary" @click="print1">打印</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {getByERPSerial} from '@/api/set/jxcstoreform';
  import CstagreementEdit from '@/components/testorder/cstagreement/CstagreementEdit';
  import BaoSunDetail from '../testorder/cstagreement/BaoSunDetail'
  import StorageBadChange from './StorageBadChange'

  export default {
    name: 'StorageBadOut',
    data() {
      return {
        msg: '坏件出库单',
        dialogMachiningVisible: false,
        formLabelWidth: '120px',
        controlData: {},
        handlemode:'',
        ordername:'',
        showtitle1:"none",
        tableData: [],
        showJingJia:false,
        showJingPian:false,
      }
    },
    methods: {
      changeHandlemodel() {
        this.controlData.handlemode=this.handlemode;
        this.$refs.StorageBadChange.initData(this.controlData,this.tableData);
      },
      afterChangeBad(row){
        this.handlemode=row.handlemode;
        this.controlData.handlemode=row.handlemode;
        this.controlData.customerserial=row.customerserial
        this.controlData.customername=row.customername
      },
      print1() {
        this.showtitle1 = ""
        this.$nextTick(() => {
          this.$print(this.$refs.print1)
          this.showtitle1 = "none"
        })
      },
      getPack(packagesize,col,formproperty) {
        var v = '';

        if (packagesize) {
          v = JSON.parse(packagesize)[col];
          if(v==null)
            v='';
          else{
            if(col=='M')
              this.showJingJia=true;
            if(col=='Y')
              this.showJingPian=true;
          }
        }
        if(!v&&col=='type'&&formproperty){
          v = JSON.parse(formproperty)[0][col];
          if(v==null)
            v='';
        }
        return v;
      },
      getPackagesize(packagesize) {
        let s = ""
        if (packagesize) {
          let temp = JSON.parse(packagesize)
          s = "S:" + (parseFloat(temp.Y) > 0 ? "+" + temp.Y : temp.Y) + ",C:" + (parseFloat(temp.X) > 0 ? "+" + temp.X : temp.X)
          if (temp.type) {
            s = temp.type + " " + s
          }
        }
        return s
      },
      //查看订单
      lookdingdan(item) {
        if (item["ordernum"]) {
          var s = {
            erpserial: item["ordernum"]
          }
          if(item["ordernum"].startsWith('78')){
            this.lookbaosundan(s);
            return;
          }
          this.$refs.DataContactEdit.initData(s)
          this.$refs.DataContactEdit.show()
        }
      },
      lookbaosundan(item){
        this.$refs.BaoSunDetail.show(item.erpserial,false)
      },
      getTitle() {
        let result = "";
        let temp = localStorage.getItem("hpapi_userInfoModel")
        if (temp) {
          result += JSON.parse(temp).tenantname || ""
        }
        result += "坏件出库单"
        return result
      },
      show(erpserial) {
        this.controlData = {}
        this.tableData = []
        this.dialogMachiningVisible = true;
        this.showJingJia=false;
        this.showJingPian=false;

        getByERPSerial({
          erpserial: erpserial,
          isout: "1"
        }).then(response => {
          if (response.data.code == 0) {
            this.controlData = response.data.main
            this.tableData = response.data.list
            this.handlemode=this.tableData[0].handlemode
            this.controlData.buyerpserial=this.tableData[0].buyordernum
          }
        })
      },
    },
    mounted() {

    },
    components: {
      BaoSunDetail,
      CstagreementEdit,
      StorageBadChange
    }

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }


</style>





// WEBPACK FOOTER //
// src/components/warehouse/StorageBadOut.vue